var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-trigger",class:{open: _vm.menuOpen},on:{"click":_vm.toggleMenu}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }